import { render } from "./AccountSubcontainer2.vue?vue&type=template&id=6c270e91&scoped=true"
import script from "./AccountSubcontainer2.vue?vue&type=script&lang=js"
export * from "./AccountSubcontainer2.vue?vue&type=script&lang=js"

import "./AccountSubcontainer2.vue?vue&type=style&index=0&id=6c270e91&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c270e91"

export default script